import type { StoreCatalogItem } from './types'

export type StoreRewardCategoryRef = {
  id: string
  name: string
}

/**
 * A categoria que o participante navega é a do **reward** (kind `reward`, de
 * vitrine). A do item é de precificação — define o preço, e o nome dela
 * ("Brindes (preço)") não é o que se quer ler num filtro. Só cai na do item
 * quando o reward não tem agrupamento, para o item não ficar sem categoria.
 */
export const resolveItemRewardCategory = (
  item: StoreCatalogItem
): StoreRewardCategoryRef | null => {
  const category = item.reward?.reward_category ?? item.reward_category

  if (!category?.id || !category.name?.trim()) {
    return null
  }

  return {
    id: String(category.id),
    name: category.name.trim()
  }
}

export const resolveItemRewardCategoryId = (
  item: StoreCatalogItem
): string | null => resolveItemRewardCategory(item)?.id ?? null
